import { useTheme } from 'styled-components'

import { useStatus } from '@hooks/status'

import { PillBox } from './styles'

interface IStatusPillProps {
  isTeco?: boolean
  status: string
}

export function StatusPill({ isTeco = false, status }: IStatusPillProps) {
  const { getStatusIdByName, getStatusColorById } = useStatus()
  const theme = useTheme()
  const taskStatusNumber = getStatusIdByName(status)
  const taskStatusColor = getStatusColorById(taskStatusNumber)

  const color = isTeco ? theme.colors.taskTeco : taskStatusColor

  return <PillBox statusColor={color} />
}
